export default __webpack_public_path__ + "geekfood.png";